import { LISTING_API_PREFIX } from 'src/common/constants';
import { apiRequest } from 'src/common/utils/apiFetch';
import captureException from 'src/common/utils/captureException';

export const submitListingForReview = async (listingId: string): Promise<boolean> => {
  const url = `${LISTING_API_PREFIX}${listingId}/changesets`;
  try {
    const response = await apiRequest(url, {
      method: 'POST',
      body: JSON.stringify({}),
    });
    if (response.ok && response.status === 200) {
      return true;
    }
  } catch (error) {
    captureException(error);
  }
  return false;
};

const bulkSubmitListingsForReview = async (listingIds: string[]): Promise<boolean> => {
  if (listingIds.length === 0) {
    return false;
  }

  if (listingIds.length === 1) {
    return submitListingForReview(listingIds[0]);
  }

  const promises: Promise<boolean>[] = [];
  for (const listingId of listingIds) {
    promises.push(submitListingForReview(listingId));
  }

  const results = await Promise.allSettled(promises);
  return results.every((result) => result);
};

export default bulkSubmitListingsForReview;
